import { NAMESPACE } from 'i18n/i18n'
import { useTranslation, UseTranslationOptions } from 'react-i18next'

export const useTranslationPrefix = (
  prefix: string,
  options?: UseTranslationOptions
) => useTranslation(NAMESPACE, { keyPrefix: prefix, ...options })
